import HcpDosing from "@/page-components-hcp/dosing";

export default function HcpDosingPage() {
  
  return <HcpDosing />;
}

// Forward layout props to `_app` so it can wrap with the proper layout
HcpDosingPage.getLayoutProps = (pageProps, router) => (
  typeof HcpDosing.getLayoutProps === 'function'
    ? HcpDosing.getLayoutProps(pageProps, router)
    : {}
);